import { toSubscriptionCode, type Subscription } from '@/lib/subscription'

/**
 * Returns the dev-bypass subscription if and only if we're running in Vite
 * dev mode AND the bypass env var is set. In production builds this always
 * returns null (the bypass env vars aren't baked into the prod bundle).
 */
export function getDevBypassSubscription(): Subscription | null {
  if (!import.meta.env.DEV) return null
  const id = import.meta.env.VITE_DEV_BYPASS_SUBSCRIPTION_ID
  if (typeof id !== 'string' || id.trim() === '') return null
  const name =
    import.meta.env.VITE_DEV_BYPASS_SUBSCRIPTION_NAME?.trim() || 'Dev bypass subscription'
  return { id: id.trim(), code: toSubscriptionCode(id.trim()), name }
}

export function getDevBypassToken(): string | null {
  if (!import.meta.env.DEV) return null
  const token = import.meta.env.VITE_DEV_BYPASS_TOKEN
  if (typeof token !== 'string' || token.trim() === '') return null
  return token.trim()
}
